import React from "react";
import { IAsyncData } from "../../../../../core/models";
import { IApartment } from "../../data/entities";
import { ROUTES } from "../../../../../routes";
import { ExtendedLink } from "../../../../../i18n";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface IProps {
  apartmentDetailBranch: IAsyncData<IApartment>;
  projectId: string;
  onPageChange: (params: any) => void;
}

const Title = styled.h4`
  text-align: center;
  margin: 0.75rem 0.75rem 0;
  font-size: 0.9rem;
  line-height: 1.35;
  color: white !important;
  padding: 10px 14px;
  background: #223a5e;
  border-radius: 22px;

  @media screen and (max-width: 1100px) {
    margin: 0.5rem 0.5rem 0;
    padding: 8px 12px;
    font-size: 0.85rem;
  }
`;

export const ApartmentTopNav: React.FC<IProps> = ({
  apartmentDetailBranch, projectId, onPageChange
}: IProps) => {
  return (
    <Title>
      <ExtendedLink to=""
        onClick={() => onPageChange({
          route: ROUTES.project,
        })}>
        <b className="t-color4">{`Bina ${apartmentDetailBranch.data?.buildingNumber} > `}</b>
      </ExtendedLink>

      <ExtendedLink to=""
        onClick={() => onPageChange({
          route: ROUTES.sector,
          param1: projectId,
          param2: apartmentDetailBranch.data?.sectorId,
        })}
      >
        <b className="t-color4">{`Giriş ${apartmentDetailBranch.data?.entranceNumber}`}</b>
      </ExtendedLink>

      <ExtendedLink to=""
        onClick={() => onPageChange({
          route: ROUTES.floor,
          param1: projectId,
          param2: apartmentDetailBranch.data?.sectorId,
          param3: apartmentDetailBranch.data?.floorId,
        })}
      >
        <b className="t-color4">{` > Mərtəbə ${apartmentDetailBranch.data?.floorNumber}`}</b>
      </ExtendedLink>

      <span>{` > Mənzil ${apartmentDetailBranch.data?.apartmentNumber}`}</span>
    </Title>
  );
};
